import { Component, EventEmitter, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastService } from 'angular-toastify';
import { ApiAuthService } from '../../../../../core/services/api/auth/api-auth.service';

@Component({
  selector: 'app-modal-change-my-password',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-change-my-password.component.html',
  styleUrl: './modal-change-my-password.component.css',
})
export class ModalChangeMyPasswordComponent {
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();

  currentPassword = '';
  newPassword = '';
  confirmPassword = '';

  showCurrentPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  isSaving = signal(false);

  private api = inject(ApiAuthService);
  private toast = inject(ToastService);

  onClose(): void {
    if (this.isSaving()) return;
    this.close.emit();
  }

  onSave(): void {
    if (this.isSaving()) return;

    if (!this.currentPassword) {
      this.toast.error('กรุณากรอกรหัสผ่านเดิม');
      return;
    }
    if (!this.newPassword) {
      this.toast.error('กรุณากรอกรหัสผ่านใหม่');
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      this.toast.error('รหัสผ่านใหม่และยืนยันรหัสไม่ตรงกัน');
      return;
    }

    this.isSaving.set(true);
    this.api.changeMyPassword({
      currentPassword: this.currentPassword,
      newPassword: this.newPassword,
    }).subscribe({
      next: (res) => {
        this.isSaving.set(false);
        if (!res?.isSuccess) {
          this.toast.error(res?.message || 'เปลี่ยนรหัสผ่านไม่สำเร็จ');
          return;
        }
        this.toast.success('เปลี่ยนรหัสผ่านเรียบร้อย');
        this.saved.emit();
        this.close.emit();
      },
      error: () => {
        this.isSaving.set(false);
        this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
      },
    });
  }
}
